<!-- SwipFx Orders Page - Filterable Order Book (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">

    <app-header [page]="'Accounts'"></app-header>
    <main class="container py-4">

        <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
                <h4 class="fw-bold mb-0">Application Details</h4>
                <div class="text-muted small">Review your verification application</div>
            </div>

            <div class="d-flex gap-2">
                <button class="btn btn-outline-secondary btn-sm" routerLink="/compliance">
                    Back
                </button>

                <button *ngIf="canContinue()" class="btn btn-outline-primary btn-sm" (click)="continueApplication()">
                    Continue
                </button>

                <button *ngIf="canResubmit()" class="btn btn-primary btn-sm" (click)="resubmit()">
                    Resubmit
                </button>
                <button *ngIf="canDelete()" class="btn btn-outline-danger btn-sm" [disabled]="deleteBusy"
                    (click)="deleteApplication()">
                    <span *ngIf="deleteBusy" class="spinner-border spinner-border-sm me-2"></span>
                    Delete
                </button>
            </div>
        </div>

        <div *ngIf="loading" class="text-center py-4">
            <div class="spinner-border"></div>
        </div>

        <div *ngIf="error" class="alert alert-danger">
            {{ error }}
        </div>

        <ng-container *ngIf="!loading && application as app">

            <div class="card shadow-sm border-0 mb-4">
                <div class="card-body">
                    <div class="row g-3">
                        <div class="col-md-3">
                            <div class="text-muted small">Country</div>
                            <div class="fw-semibold">{{ app.jurisdictionCode }}</div>
                        </div>

                        <div class="col-md-3">
                            <div class="text-muted small">Tier</div>
                            <div class="fw-semibold">{{ app.tierCode }}</div>
                        </div>

                        <div class="col-md-3">
                            <div class="text-muted small">Product</div>
                            <div class="fw-semibold">{{ app.productType }}</div>
                        </div>

                        <div class="col-md-3">
                            <div class="text-muted small">Status</div>
                            <span class="badge" [ngClass]="getStatusClass(app.status)">
                                {{ app.status }}
                            </span>
                        </div>

                        <div class="col-md-3">
                            <div class="text-muted small">Started</div>
                            <div class="fw-semibold">{{ app.startedAt | date:'medium' }}</div>
                        </div>

                        <div class="col-md-3" *ngIf="app.submittedAt">
                            <div class="text-muted small">Submitted</div>
                            <div class="fw-semibold">{{ app.submittedAt | date:'medium' }}</div>
                        </div>

                        <div class="col-md-3" *ngIf="app.approvedAt">
                            <div class="text-muted small">Approved</div>
                            <div class="fw-semibold">{{ app.approvedAt | date:'medium' }}</div>
                        </div>

                        <div class="col-md-3" *ngIf="app.rejectedAt">
                            <div class="text-muted small">Rejected</div>
                            <div class="fw-semibold">{{ app.rejectedAt | date:'medium' }}</div>
                        </div>
                    </div>

                    <div *ngIf="app.reviewNotes" class="alert alert-warning mt-3 mb-0">
                        <strong>Review notes:</strong> {{ app.reviewNotes }}
                    </div>
                </div>
            </div>

            <div class="row g-4">
                <div class="col-lg-6">
                    <div class="card shadow-sm border-0 h-100">
                        <div class="card-body">
                            <h5 class="mb-3">Field Values</h5>

                            <div *ngIf="!app.fields?.length" class="text-muted small">
                                No field values yet.
                            </div>

                            <div *ngFor="let field of app.fields; trackBy: trackByField" class="border-bottom py-2">
                                <div class="text-muted small">{{ field.label || field.fieldKey }}</div>
                                <div class="fw-semibold">{{ field.fieldValue || '-' }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="card shadow-sm border-0 h-100">
                        <div class="card-body">
                            <h5 class="mb-3">Documents</h5>

                            <div *ngIf="!app.documents?.length" class="text-muted small">
                                No documents uploaded yet.
                            </div>

                            <div *ngFor="let doc of app.documents; trackBy: trackByDoc" class="border rounded p-3 mb-2">
                                <div class="d-flex justify-content-between align-items-start gap-2">
                                    <div>
                                        <div class="fw-semibold">{{ doc.label || doc.documentTypeCode }}</div>
                                        <div class="small text-muted">{{ doc.fileName }}</div>
                                        <div class="small text-muted">{{ doc.mimeType }}</div>
                                    </div>

                                    <span class="badge" [ngClass]="getStatusClass(doc.status)">
                                        {{ doc.status }}
                                    </span>
                                </div>

                                <div *ngIf="doc.expiryDate" class="small text-muted mt-2">
                                    Expiry: {{ doc.expiryDate | date:'mediumDate' }}
                                </div>

                                <div *ngIf="doc.rejectionReason" class="small text-danger mt-2">
                                    {{ doc.rejectionReason }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>
        <app-footer></app-footer>
    </main>
</div>